import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import CheckListItem from './CheckListItem';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;

const CheckList = ({ items }) => (
  <StyledContainer>
    {items?.map(({ id, ...restProps }) => (
      <CheckListItem key={id} {...restProps} />
    ))}
  </StyledContainer>
);

CheckList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      hint: PropTypes.node,
      completed: PropTypes.bool,
    })
  ),
};

export default CheckList;
